document.addEventListener('DOMContentLoaded', function () {

  const billingContainer = document.querySelector('.tourmaster-payment-billing-wrap.tourmaster-form-field.tourmaster-with-border');
  const submitBtn = document.querySelectorAll('.tourmaster-tour-booking-continue');
  if (billingContainer) {
    const billingCheckbox = billingContainer.querySelector('#tourmaster-payment-billing-copy');
    if (billingCheckbox && submitBtn) {

      setTimeout(function () {
        billingCheckbox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        billingCheckbox.checked = true;

        // Hide the container
        billingContainer.style.display = 'none';
      }, 10); // 10 milliseconds delay

      submitBtn.forEach(btn => {
        btn.addEventListener('click', function () {
          billingCheckbox.checked = false;
          billingCheckbox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          billingCheckbox.checked = true;
        });
      });
    }
  }

  // Add passport info text on page 2039 with tourmaster-payment parameter
  function addPassportInfo() {
    // Check if we're on the correct page and have the payment parameter
    if (document.body.classList.contains('page-id-2039') && window.location.search.includes('tourmaster-payment')) {
      // Find the traveller info title
      const travellerInfoTitle = document.querySelector('.tourmaster-payment-traveller-info-title');

      if (travellerInfoTitle && !travellerInfoTitle.nextElementSibling?.classList.contains('passport-info')) {
        // Create the paragraph element
        const passportInfo = document.createElement('p');
        passportInfo.className = 'passport-info';
        passportInfo.textContent = 'Prosimy o podanie dokładnie tych samych danych podróżnika, które mają Państwo podane w paszporcie, na którym będą Państwo podróżować (w tym oba imiona / nazwiska jeśli występują)';

        // Insert after the h3 element
        travellerInfoTitle.insertAdjacentElement('afterend', passportInfo);
      }
    }
  }

  // Run immediately
  addPassportInfo();

  // Also observe for dynamic content changes
  const observer = new MutationObserver(function (mutations) {
    addPassportInfo();
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


